import React from 'react'

import CardCourses from './cardCourses'
import { CourseProps } from '../../../types'

import { ContentSectionCourses } from './styles'

type CoursesSectionProps = {
  courses: CourseProps[]
}

const CoursesSection = ({ courses }: CoursesSectionProps) => {
  return (
    <ContentSectionCourses>
      {courses.map((course) => {
        return <CardCourses key={course.uid} course={course} />
      })}
    </ContentSectionCourses>
  )
}

export default CoursesSection
